<template>
  <div class="information" style="min-height:50vw;">
    <div class="container clearf">
      <div class="left-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>搜索列表</el-breadcrumb-item>
        </el-breadcrumb>
        <ul class="info-list">
          <li class="list-style2" v-for="(item,index) in searchList" :key="index">
            <router-link
              class="list-title"
              :to="{path:'/searchDetails',query:{id:item.tid,type:item.type}}"
            >{{item.title}}</router-link>
            <div class="style-box clearf">
              <div class="left" v-if="item.coverUrl">
                <img :src="$img + item.coverUrl" />
              </div>
              <div class="right" :style="{width:item.coverUrl?'calc(100% - 220px)':'100%'}">
                <p>{{item.summary}}</p>
                <div class="list-bottom">
                  <span>
                    <i class="iconfont icon-shijian"></i>
                    {{item.publishDate | formatDate}}
                  </span>
                  <span>发布人：{{item.publishBy}}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next,jumper"
          :total="total"
        ></el-pagination>
      </div>
      <div class="right-box">
        <recommendation />
      </div>
    </div>
  </div>
</template>

<script>
import recommendation from "../components/recommendation";
import "@/assets/iconfont/iconfont.css";
import { log } from "util";
export default {
  data() {
    return {
      //分页数据
      currentPage: 1,
      pageSize: 20,
      pageNum: 1,
      total: 0,
      page: 1,
      searchContent: "",
      searchList: [],
      inputStage: ""
    };
  },
  components: {
    recommendation
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;
    }
  },
  created() {
    this.inputStage = sessionStorage.getItem("inputStage");
    console.log(this.inputStage);
    this.getParams();
    this.getsearchList();
  },
  mounted() {},
  watch: {
    $route(to, from) {
      location.reload();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getsearchList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getsearchList();
    },
    getParams() {
      // 取到路由带过来的参数
      let routeParams = this.$route.query.searchContent;
      // console.log(routeParams);
      // 将数据放在当前组件的数据内
      if (routeParams !== undefined) {
        this.searchContent = routeParams;
      }
    },
    getsearchList() {
      let para = {
        searchContent: this.searchContent || this.inputStage,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$axios({
        methods: "get",
        url: " /zs/search/querySearchPage",
        params: para
      }).then(res => {
        let newsData = JSON.parse(res.data).respData.content;
        let topNewsData = JSON.parse(res.data).respData;
        this.total = topNewsData.totalElements;
        this.searchList = newsData;
      });
    }
  }
};
</script>

<style lang="less">
//element样式修改
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
  &:hover {
    color: #333;
  }
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
  &:hover {
    color: #149508;
  }
}
.el-breadcrumb__separator {
  color: #333;
}
.el-pager li.active {
  color: #149508;
}
.el-pagination {
  padding: 20px 0;
  margin: 0 auto;
  text-align: center;
}
.el-pager li:hover {
  color: #149508;
}

.left-box {
  float: left;
  width: 848px;
  margin-top: 20px;
  .info-list {
    li {
      position: relative;
      width: 100%;
      background-color: #fff;
      margin-top: 15px;
      padding: 20px;
      .list-title {
        display: block;
        font-size: 18px;
        color: #333;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 808px;
        &:hover {
          color: #149508;
        }
      }
      .style-box {
        margin: 10px 0;
        p {
          color: #666;
          line-height: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
      .left {
        float: left;
        width: 200px;
        height: 133px;
        margin-right: 20px;
      }
      .right {
        float: left;
        width: calc(100% - 220px);
        // width: auto;
      }
      .list-bottom {
        position: absolute;
        bottom: 5px;
        right: 20px;
        color: #999;
        font-size: 14px;
        span {
          margin-left: 30px;
          i {
            margin-right: 5px;
          }
        }
      }
    }
  }
}
.right-box {
  float: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/seachlist.vue